<template>
    <div class="contents">
        <!-- <div class="name">
            <img v-if="dataDetail.imageUrl" :src="dataDetail.imageUrl" alt="">
            <span>{{dataDetail.businessName}}</span>
        </div> -->
        <el-row class="intro-y box overflow-hidden mt-5 info">
            <el-col :span="12">
                <div class="item">
                    <label>法定代表人：</label>
                    <span class="blue">{{dataDetail.legalRepresentative}}</span>
                </div>
                <div class="item">
                    <label>注册资本：</label>
                    <span>{{dataDetail.registerCapital}}万</span>
                </div>
                <div class="item">
                    <label>实缴资本：</label>
                    <span class="red">{{dataDetail.contributCapital}}万</span>
                </div>
                <div class="item">
                    <label>经营状态：</label>
                    <span>{{dataDetail.status}}</span>
                </div>
                <div class="item">
                    <label>成立日期：</label>
                    <span>{{dataDetail.startDate}}</span>
                </div>
                <div class="item">
                    <label>统一社会信用代码：</label>
                    <span>{{dataDetail.creditCode}}</span>
                </div>
                <div class="item">
                    <label>纳税人识别号：</label>
                    <span>{{dataDetail.recognitionNumber}}</span>
                </div>
                <div class="item">
                    <label>注册号：</label>
                    <span>{{dataDetail.businessRegistrationNumber}}</span>
                </div>
                <div class="item">
                    <label>组织机构代码：</label>
                    <span>{{dataDetail.institutionCode}}</span>
                </div>
                <div class="item">
                    <label>企业类型：</label>
                    <span class="blue">{{dataDetail.companyType}}</span>
                </div>
                

            </el-col>
            <el-col :span="12">
                <div class="item">
                    <label>所属行业：</label>
                    <span>{{dataDetail.industryInvolved}}</span>
                </div>
                <div class="item">
                    <label>核准日期：</label>
                    <span>{{dataDetail.approvalDate}}</span>
                </div>
                <div class="item">
                    <label>登记机关：</label>
                    <span>{{dataDetail.registrationAuthority}}</span>
                </div>
                <div class="item">
                    <label>所属地区：</label>
                    <span>{{dataDetail.province}}</span>
                </div>
                <div class="item">
                    <label>英文名称：</label>
                    <span>{{dataDetail.englishName}}</span>
                </div>
                <div class="item">
                    <label>曾用名：</label>
                    <span>{{dataDetail.usedName}}</span>
                </div>
                <div class="item">
                    <label>参保人数：</label>
                    <span>{{dataDetail.insuredCount}}</span>
                </div>
                <div class="item">
                    <label>人员规模：</label>
                    <span>{{dataDetail.personScope}}</span>
                </div>
                <div class="item">
                    <label>营业期限：</label>
                    <span>{{dataDetail.businessTerm}}</span>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
  name:'industrialCommercialInfo',
  props:['dataDetail'],
}
</script>
<style lang="scss" scoped>
.contents{
    background: #fff;
    .name{
        margin:20px 0;
        img{
            border:1px solid #ddd;
            width:70px;
            height:70px;
            display:inline-block;
            margin-right: 18px;
            vertical-align: middle;
        }
        span{
            font-size: 18px;
            vertical-align: middle;
        }
    }
    .info{
      padding:24px;
        .item{
            margin-bottom: 15px;
            span{
                color:#707070;
            }
        }
    }
}
</style>
